module.exports = __webpack_public_path__ + "media/images/icon__locked@2x-ca04aa00fe18b9d887119800b2fc8673.png";